import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"search\"><path d=\"M502 451L349 304c22-32 35-67 35-109C384 93 298 6 192 6S0 90 0 195c0 103 86 189 192 189 42 0 80-13 112-35l150 147c13 13 36 16 48 3 13-16 13-35 0-48zM64 195c0-70 58-125 128-125s128 58 128 125-58 125-128 125S64 262 64 195z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search.svg
// module id = 205
// module chunks = 0